module.exports = __webpack_public_path__ + "img/burger-close.fbdfb79e.svg";